"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.find3DApps = void 0;
const find3DApps = () => {
    return Array.from(document.querySelectorAll("[data-3d-app]")).map((el) => {
        const node = el.getAttribute("data-3d-app");
        if (!node) {
            return;
        }
        try {
            const data = JSON.parse(node);
            return Object.assign(Object.assign({}, data), { element: el, descriptions: new Map(Object.entries(data.description)) });
        }
        catch (error) {
            return [];
        }
    });
};
exports.find3DApps = find3DApps;
